module.exports = __webpack_public_path__ + "img/hum.0b3cc12b.svg";